var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.9,235.1c28.2,0,51.2-22.9,51.2-51.1c0-28.2-22.9-51.2-51.2-51.2s-51.1,22.9-51.1,51.2 C180.8,212.2,203.7,235.1,231.9,235.1z M231.9,162.8c11.7,0,21.2,9.5,21.2,21.2c0,11.7-9.5,21.1-21.2,21.1 c-11.7,0-21.1-9.5-21.1-21.1C210.8,172.3,220.2,162.8,231.9,162.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M493.2,37H18.8C8.4,37,0,45.4,0,55.8v401.4c0,10.4,8.4,18.8,18.8,18.8h474.3c10.4,0,18.8-8.4,18.8-18.8V55.8 C512,45.4,503.6,37,493.2,37z M482,67.1V304c0,0.1-0.2,0.2-0.3,0.1l-94.1-94.1c-6.2-6.1-16.2-6.1-22.3,0L232,343.4 c-0.1,0.1-0.2,0.1-0.2,0l-85.1-85.1c-3.1-3.1-7.2-4.7-11.5-4.6c-4.2,0.1-8.2,2-11.2,5l-93.7,93.7c-0.1,0.1-0.3,0-0.3-0.1V67.1 c0-0.1,0.1-0.1,0.1-0.1h451.7C481.9,67,482,67.1,482,67.1z M30,446v-50.9c0,0,0-0.1,0-0.1l105.4-105.4c0.1-0.1,0.2-0.1,0.2,0 l84.9,84.9c2.4,2.4,5.5,4.1,8.8,4.7c5.2,0.8,10.2-0.8,13.8-4.4l133.3-133.3c0.1-0.1,0.2-0.1,0.2,0L482,346.8c0,0,0,0.1,0,0.1V446 c0,0.1-0.1,0.1-0.1,0.1H30.1C30.1,446.1,30,446.1,30,446z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscape);
export default __webpack_public_path__ + "static/media/Landscape.8bdbcfb2.svg";
export { ForwardRef as ReactComponent };